export default {
    getItem: (state) => (itemId) => {
        return state.items[itemId];
    },
    getQRCodeModal(state) {
        return state.QRCodeModal;
    },
    getItems(state) {
        return state.items;
    },
    getLiveFreshItem(state) {
        return state.liveFreshItem;
    },
    getPromoValue(state) {
        return state.promoValue;
    },
    getPromoDiscount(state) {
        return state.promoDiscount;
    },
    getPromoTotalWithDiscount(state) {
        return state.promoTotalWithDiscount;
    },
    getPromoMessage(state) {
        return state.promoMessage;
    },
    getPaymentData(state) {
        return state.paymentData;
    },
    getCartTotalDiscount(state) {
        if (state.promoTotal == 0) {
            return state.getCartTotal;
        }
        return state.promoTotal - state.promoTotalWithDiscount;
    },
    getCartOpenState(state) {
        return state.isCartOpenState;
    },
    getCartTotal(state, _, __, rootGetters) {
        let total = 0;
        for (const item in state.items) {
            let elem = state.items[item];
            let id = elem.id;
            let liveElem = state.liveItems.filter((liveElemItem) => liveElemItem.id == id)[0];
            let locale = rootGetters["globalvars/getLocale"];
            if (liveElem && locale) {
                if (liveElem.in_stock || liveElem.is_always_available) {
                    let price = liveElem.currencies[locale.currency.currencyCode];
                    if (liveElem.discount || liveElem.fullPrice != liveElem.price) {
                        total += (price.discount_price ? price.discount_price : price.price) * elem.count;
                    } else {
                        total += price.price * elem.count;
                    }
                }
            }
        }
        // state.cartTotal = total;
        return Math.floor(total).toLocaleString("ru-RU");
    },
    getLiveItemById: (state) => (itemId) => {
        return state.liveItems.filter((liveItem) => liveItem.id == itemId)[0];
    },
    getLiveItems(state) {
        return state.liveItems;
    },
    getAppliedBonuses(state) {
        return state.appliedBonuses;
    },
    getDiscountInfo(state) {
        return state.discountInfo;
    },
    isDeliveresLoading(state) {
        return state.isDeliveresLoading;
    },
};
